import { FormEvent, useEffect, useState } from 'react';
import useModifiers from 'hooks/useModifiers';
import { RegisterOptions, useFormContext } from 'react-hook-form';
import { FormGroupModifier } from 'models/form';
import Tooltip, { TooltipAlignEnum } from '../tooltip';

export enum FormCheckboxModifier {
  OLD = 'old',
}

export interface FormCheckboxTooltipProps {
  title?: string;
  message?: string;
  align: TooltipAlignEnum;
}

export interface FormCheckboxProps {
  name: string;
  options?: RegisterOptions;
  label?: string;
  desc?: string;
  narrow?: boolean;
  modifiers?: FormCheckboxModifier[];
  toggle?: boolean;
  defaultChecked?: boolean;
  tooltip?: FormCheckboxTooltipProps;
  onChange: (v: boolean) => void;
}

function FormCheckbox(props: FormCheckboxProps) {
  const {
    name, options, narrow, toggle, defaultChecked, desc, label = '', tooltip
  } = props;

  const mods = useModifiers(props.modifiers);
  const formContext = useFormContext();
  const [inputValue, setInputValue] = useState(defaultChecked || false);

  const isDisabled = options && options.disabled;

  const disabledMod = isDisabled ? FormGroupModifier.DISABLED : '';
  const narrowMod = narrow ? FormGroupModifier.NARROW : '';
  const toggleMod = toggle ? '_toggle' : '_default';

  useEffect(() => {
    props.onChange(inputValue);
  }, [inputValue]);

  const handleInputChange = (e: FormEvent<HTMLInputElement>) => {
    const currentInput = e.currentTarget.checked;
    setInputValue(currentInput);
  };

  const checkboxElement = (
    <div className={`ct_form-group ${disabledMod} ${narrowMod}`}>
      <div className="ct_form-control">
        <input
          className={`ct_checkbox ${toggleMod} ${mods}`}
          id={`checkbox_${name}`}
          type="checkbox"
          {...formContext.register(name, options)}
          defaultChecked={defaultChecked}
          onChange={handleInputChange}
        />
          <label htmlFor={`checkbox_${name}`}>
            {label}
            {isDisabled && desc && (
              <>
                <br />
                <span>{desc}</span>
              </>
            )}
          </label>
      </div>
    </div>
  );

  return !!tooltip
    ? <Tooltip align={tooltip.align} title={tooltip.title} message={tooltip.message}>{checkboxElement}</Tooltip>
    : checkboxElement;
}

FormCheckbox.defaultProps = { ...{ defaultChecked: false, onChange: () => {} } };

export default FormCheckbox;
